'use strict';

/**
 *
 * @name: playerDrawer
 *
 */

import DirectiveTemplate from './nn-player-drawer.directive.html';
import './nn-player-drawer.directive.scss';

function PlayerDrawerDirective(
  $rootScope,
  $location,
  $state,
  $timeout,
  transObject,
  localPlaylist,
  playersAnalytics
) {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    link: function (scope) {

      /*
       *
       * @CONFIG
       *
       */
      var selectedItem = $rootScope.bWidth < 600 ? '' : 'items';
      var rootWatchers = {};
      $rootScope.playlist.settings.active = false;
      $rootScope.localPlaylist = localPlaylist;

      scope.mobileSwiperVisible = false

      scope.swiperOptions = {
        direction: window.innerWidth < 600 ? 'vertical' : 'horizontal',
        spaceBetween: window.innerWidth < 600 ? 15 : 30,
      }

      /*
       *
       * @PUBLIC
       *
       */

      scope.setSource = function (source) {

        selectedItem = source;
        $rootScope.playlist.settings.active = false;

        localPlaylist
          .changeSource(source)
          .then(function () {

            playersAnalytics.drawerAction(source);
            scope.bookmarkPlaylistConfig.source = $rootScope.playlist[source];

            _refreshSwiper()

          });
      };

      scope.isItemSelected = function (type) {

        return selectedItem === type;
      };

      scope.toggleMobileSwiper = (val = 'toggle') => {
        scope.mobileSwiperVisible = val === 'toggle' ? !scope.mobileSwiperVisible : val
      }

      scope.startAndSetCurrentItem = function (index, item) {

        $rootScope.playlist.settings.active = true;
        $rootScope.playlist.settings.justChanged = true;
        hideDrawerVideo()
        localPlaylist.startAndSetCurrentItem(index, item);
      };

      /*
       *
       * @PRIVATE
       *
       */

      function _refreshSwiper () {
        if (scope.baseSwiper) {
          scope.baseSwiper.slideTo(0, 0)
          scope.baseSwiper.setUpdate()
        }
      }

      function hideDrawerVideo () {
        $rootScope.showDrawerVideo = false;
      }

      function setBookmarkPlaylistConfig() {
        scope.bookmarkPlaylistConfig = {
          currentStory: localPlaylist.returnCurrentItem(),
          source: $rootScope.playlist ? $rootScope.playlist.items : []
        };
      }


      /*
       *
       * @INIT
       *
       */

      scope.$watch('bookmarkPlaylistConfig.source', () => {
        // needed when user adds/removes new video to queue
        if(scope.baseSwiper) {
          scope.baseSwiper.setUpdate()
        }
      }, true)

      setBookmarkPlaylistConfig();

      rootWatchers.playlist = $rootScope.$watch('playlist', function () {
        setBookmarkPlaylistConfig();
      });

      scope.$on('$destroy', () => {
        Object.keys(rootWatchers).forEach(killWatcherKey => {
            rootWatchers[killWatcherKey]()
        })
      })
    }
  };
}

export default PlayerDrawerDirective;



// WEBPACK FOOTER //
// ./app/components/nn-player-drawer/nn-player-drawer.directive.js